module.exports = __webpack_public_path__ + "img/small-TopBanner.ab452872.png";